export const formatSize = (size: string): string => {
  const toReplace = '.00';

  if (size.endsWith(toReplace)) {
    return size.replace(toReplace, '');
  }

  return size;
};

export const calcFileSizeFromBytes = (usedBytes: number): string => {
  const kilobytes = usedBytes / 1024; // 1 KB = 1024 B
  const megabytes = kilobytes / 1024; // 1 MB = 1024 KB
  const gigabytes = megabytes / 1000; // 1 GB = 1000 MB

  if (megabytes >= 1000) {
    return `${formatSize(gigabytes.toFixed(2))} GB`;
  }

  if (megabytes >= 0.01) {
    return `${formatSize(megabytes.toFixed(2))} MB`;
  }

  if (kilobytes >= 0.01) {
    return `${formatSize(kilobytes.toFixed(2))} KB`;
  }

  return `${formatSize(usedBytes.toFixed(2))} B`;
};
